import { default as Modal } from './AbstractModal';

export default class extends Modal {
    /**
     * The CSS class name to apply to `<html>` to mark the modal as open.
     *
     * @var {string}
     */
    activeClass = 'has-popup-open'

    onOpen() {
        this.el.classList.add('is-active')
    }

    onClose() {
        this.el.classList.remove('is-active')
    }
}